import { useLogiConfig, useLogiReportsTranslation } from '../../../../ui/hooks';
import { PageError } from '@juvare/common-web-ui/PageError';
import { PageHeaderWithImage } from '@juvare/common-web-ui/PageHeader';
import { LogiInventoryDashboard } from '@juvare/logi-library';
import { CircularProgress } from '@mui/material';
import { DashboardSettingKeys } from 'logi-embed';
import React from 'react';
import { useNavigate } from 'react-router';
export const DashboardList = ({ hideHeader }) => {
    const { t } = useLogiReportsTranslation();
    const navigate = useNavigate();
    const { data, isLoading, error } = useLogiConfig();
    if (isLoading) {
        return React.createElement(CircularProgress, null);
    }
    if (error) {
        return React.createElement(PageError, { error: error });
    }
    if (!data) {
        return React.createElement(PageError, { message: t('common.error') });
    }
    return (React.createElement(React.Fragment, null,
        !hideHeader && React.createElement(PageHeaderWithImage, { gradient: 'blue-base', title: t('panels.dashboards.title') }),
        React.createElement(LogiInventoryDashboard, { configuration: Object.assign(Object.assign({}, data.componentConfig), { interactivityOverrides: {
                    settings: {
                        [DashboardSettingKeys.ADD_TO_FAVORITES]: true,
                        [DashboardSettingKeys.CHANGE_DESCRIPTION]: true,
                        [DashboardSettingKeys.CHANGE_LAYOUT]: true,
                        [DashboardSettingKeys.DELETE]: true,
                        [DashboardSettingKeys.FILTER]: true,
                        [DashboardSettingKeys.RENAME]: true,
                        [DashboardSettingKeys.SCHEDULE_REPORTS]: false,
                        ['TAGS']: true,
                        ['PERMISSIONS']: true,
                    },
                    visualSettings: {},
                }, components: {
                    actions: {
                        definitions: [{ id: 'add-new-dashboard', onClick: () => navigate('new', { state: { back: true } }) }],
                    },
                    filters: {},
                    search: {},
                    searchByField: {},
                    table: {
                        columns: {
                            definitions: [
                                {
                                    colId: 'name',
                                    cellRendererParams: {
                                        onClick: (data) => data && navigate(data.inventoryItemId, { state: { back: true, dashboardName: data.name } }),
                                    },
                                },
                            ],
                        },
                    },
                } }), getToken: data.getToken, logiBaseUrl: data.logiBaseUrl })));
};
